import { SvenskdamStandaloneExpertSlider } from '@/svenskdam/components/Expert/Slider';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

export const SvenskdamLabradorExpertSlider: LabradorComponent = ({ type, meta }) => (
  <SvenskdamStandaloneExpertSlider {...withDebugMetadata({ type, meta })} />
);

export default SvenskdamLabradorExpertSlider;
